import { Image, Typography } from '@/components/atoms';
import { Link } from '@/i18n/routing';

export interface NavbarBrandProps {
  artwork?: string;
  name: string;
}

export const NavbarBrand = ({ artwork = '', name }: NavbarBrandProps) => {
  return (
    <Link href="/" className="flex items-center justify-center h-7 shrink-0">
      {artwork !== '' ? (
        <Image
          alt={name}
          src={artwork}
          width={120}
          height={40}
          className="
            h-8
            w-auto
            object-contain
          "
        />
      ) : (
        <Typography.Heading variant="h4">{name}</Typography.Heading>
      )}
    </Link>
  );
};
